import { useEffect, useState } from "react";

export function useTimeoutNotificationTimer(
  isActive: boolean,
  startTime: number | null,
  timeoutSeconds: number,
  onTimeout: () => void,
) {
  const normalizeStartTime = (time: number | null) => {
    if (!time || time <= 0) return null;
    return time < 1_000_000_000_000 ? time * 1000 : time;
  };

  const normalizedStartTime = normalizeStartTime(startTime);

  const [seconds, setSeconds] = useState(() =>
    normalizedStartTime
      ? Math.floor((Date.now() - normalizedStartTime) / 1000)
      : 0,
  );

  useEffect(() => {
    if (!isActive || !normalizedStartTime || !timeoutSeconds || timeoutSeconds <= 0) {
      setSeconds(0);
      return;
    }

    let interval: ReturnType<typeof setInterval>;

    const updateTimer = () => {
      const elapsed = Math.floor(
        (Date.now() - normalizedStartTime) / 1000,
      );

      setSeconds(elapsed);

      if (elapsed >= timeoutSeconds) {
        clearInterval(interval);
        onTimeout();
      }
    };

    interval = setInterval(updateTimer, 1000);

    updateTimer();

    return () => clearInterval(interval);
  }, [isActive, normalizedStartTime, timeoutSeconds, onTimeout]);


  return seconds;
}